import CancelOrderModule from '@/modules/cancel-order';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/cancel-order')({
  component: CancelOrderPage,
});

function CancelOrderPage() {
  return <CancelOrderModule />;
}
